import { fetchJSON } from '@eventbrite/http';
import { generateText } from '@eventbrite/openai';
import { CURATED_CATEGORY_TAG_MAP } from './models';

export async function getEventCuratedCategory(
    eventId: string,
): Promise<keyof typeof CURATED_CATEGORY_TAG_MAP | undefined> {
    return fetchJSON(
        `https://event-categorization-default-rtdb.firebaseio.com/events/${eventId}/categories.json`,
    );
}

export async function saveEventCuratedCategory(
    eventId: string,
    categoryKey: keyof typeof CURATED_CATEGORY_TAG_MAP,
) {
    return fetchJSON(
        `https://event-categorization-default-rtdb.firebaseio.com/events/${eventId}.json`,
        {
            method: 'PUT',
            body: JSON.stringify({
                categories: categoryKey,
            }),
        },
    );
}

export async function saveEventIdInCuratedCategory(
    eventId: string,
    categoryKey: keyof typeof CURATED_CATEGORY_TAG_MAP,
) {
    fetchJSON(
        `https://event-categorization-default-rtdb.firebaseio.com/categories/${categoryKey}/eventIds.json`,
    ).then((eventIds: any) => {
        eventIds = eventIds ?? {};
        eventIds[eventId] = true;

        return fetchJSON(
            `https://event-categorization-default-rtdb.firebaseio.com/categories/${categoryKey}/eventIds.json`,
            {
                method: 'PUT',
                body: JSON.stringify(eventIds),
            },
        );
    });
}

export async function generateCuratedCategory(eventUrl: string) {
    const stringifyCuratedCategoryList = Object.values(CURATED_CATEGORY_TAG_MAP)
        .map((c) => c.text)
        .join(', ');

    return generateText({
        prompt: `Select and only answer with one of the following prioritized options: "${stringifyCuratedCategoryList}". That option is the one that top defines this event ${eventUrl} even though don’t match the same sentence in the text. Don't justify the answer.`,
    });
}
